export class ValidateCrewInfo {
    active: boolean;
    blocked: boolean;
    valid: boolean;
    accessDeniedMessage: string;
    invalidFields: FieldValidation[];
}

export class FieldValidation {
    field: string;
    message: string;
}
